import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "tr", setLang: () => {} });

const DICT = {
  tr: {
    nav_home: "Ana Sayfa",
    nav_services: "Hizmetlerimiz",
    nav_projects: "Projelerimiz",
    nav_about: "Hakkımızda",
    nav_references: "Referanslar",
    nav_contact: "İletişim",
    cta_quote: "Teklif Al",
    cta_projects: "Projelerimizi İncele",
    cta_whatsapp: "WhatsApp'tan Yaz",
    cta_form: "Teklif Formu",
    cta_call: "Bizi Ara",
    stats_projects: "Tamamlanan Proje",
    stats_brands: "Çalışılan Marka",
    stats_views: "Toplam İzlenme",
    stats_years: "Yıllık Deneyim",
    brands_title: "Birlikte Çalıştığımız Markalar",
    services_kicker: "Bölüm 01 — Hizmetler",
    services_title: "Markanızı Büyüten Çözümler",
    services_desc: "İhtiyacınıza özel, yaratıcı ve ölçülebilir prodüksiyon çözümleri.",
    services_more: "Detayları İncele",
    projects_kicker: "Bölüm 02 — Portföy",
    projects_title: "Seçili Projeler",
    projects_all: "Tümü",
    project_watch: "İncele",
    bts_kicker: "Bölüm 03 — Kulisler",
    bts_title: "Kameranın Arkasında",
    about_kicker: "Bölüm 04 — Manifesto",
    about_values: "Değerlerimiz",
    process_kicker: "Bölüm 05 — Süreç",
    process_title: "Bir Projeyi Nasıl Hayata Geçiriyoruz?",
    testimonials_kicker: "Bölüm 06 — Referanslar",
    testimonials_title: "Müşterilerimizin Sesi",
    contact_kicker: "İletişim",
    contact_title: "Konuşalım.",
    contact_desc: "Formu doldurun ya da doğrudan yazın — 24 saat içinde döneriz.",
    form_name: "Ad Soyad",
    form_company: "Firma Adı",
    form_phone: "Telefon",
    form_email: "E-posta",
    form_service: "İlgilenilen Hizmet",
    form_budget: "Tahmini Bütçe",
    form_message: "Mesaj",
    form_submit: "Gönder",
    form_sent: "Mesajınız iletildi. Yakında sizi arayacağız.",
    form_error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
    admin_login: "Yönetim Girişi",
    admin_username: "Kullanıcı Adı",
    admin_password: "Şifre",
    admin_signin: "Giriş Yap",
    similar_projects: "Benzer Projeler",
    client: "Müşteri",
    service: "Hizmet",
    date: "Tarih",
    equipment: "Ekipman",
    before_after: "Öncesi & Sonrası",
  },
  en: {
    nav_home: "Home",
    nav_services: "Services",
    nav_projects: "Projects",
    nav_about: "About",
    nav_references: "References",
    nav_contact: "Contact",
    cta_quote: "Get a Quote",
    cta_projects: "Explore Projects",
    cta_whatsapp: "Chat on WhatsApp",
    cta_form: "Quote Form",
    cta_call: "Call Us",
    stats_projects: "Projects Delivered",
    stats_brands: "Brands Served",
    stats_views: "Total Views",
    stats_years: "Years of Craft",
    brands_title: "Brands We Work With",
    services_kicker: "Chapter 01 — Services",
    services_title: "Solutions That Scale Your Brand",
    services_desc: "Creative, measurable production solutions tailored to your needs.",
    services_more: "Explore",
    projects_kicker: "Chapter 02 — Portfolio",
    projects_title: "Selected Projects",
    projects_all: "All",
    project_watch: "View",
    bts_kicker: "Chapter 03 — Behind The Scenes",
    bts_title: "Behind The Camera",
    about_kicker: "Chapter 04 — Manifesto",
    about_values: "Our Values",
    process_kicker: "Chapter 05 — Process",
    process_title: "How We Bring a Project to Life",
    testimonials_kicker: "Chapter 06 — Voices",
    testimonials_title: "What Our Clients Say",
    contact_kicker: "Contact",
    contact_title: "Let's talk.",
    contact_desc: "Drop us a note or write directly — we reply within 24 hours.",
    form_name: "Full Name",
    form_company: "Company",
    form_phone: "Phone",
    form_email: "Email",
    form_service: "Service of Interest",
    form_budget: "Estimated Budget",
    form_message: "Message",
    form_submit: "Submit",
    form_sent: "Your message was sent. We'll reach out shortly.",
    form_error: "Something went wrong. Please try again.",
    admin_login: "Admin Access",
    admin_username: "Username",
    admin_password: "Password",
    admin_signin: "Sign In",
    similar_projects: "Similar Projects",
    client: "Client",
    service: "Service",
    date: "Date",
    equipment: "Equipment",
    before_after: "Before & After",
  },
};

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ixirli_lang") || "tr");
  useEffect(() => {
    localStorage.setItem("ixirli_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key) => DICT[lang][key] ?? key;
  const pick = (obj, base) => obj?.[`${base}_${lang}`] ?? obj?.[`${base}_tr`] ?? "";
  return (
    <LangContext.Provider value={{ lang, setLang, t, pick }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
